import { render, staticRenderFns } from "./jobs-overview.vue?vue&type=template&id=f60d3004"
import script from "./jobs-overview.vue?vue&type=script&lang=js"
export * from "./jobs-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports